module.exports = __webpack_public_path__ + "img/undertakingCases16.b07a2610.jpg";